import { Component, ViewEncapsulation } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { IndividualConfig, ToastrService } from 'ngx-toastr'
import { constants } from '../environments/environment'

@Component({
  selector: 'flytrex-root',
  templateUrl: './app.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./scss/application.scss'],
})
export class AppComponent {
  currentTitle = `Flytrex (${constants.envName})`
  constructor(private titleService: Title) {
    this.titleService.setTitle(this.currentTitle)
  }
}
